import Drawer from '@mui/material/Drawer';
import clsx from 'clsx';
import { ReactNode, forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { Position } from '../../../core/enums/position.enum';
import { SwipeableDrawer } from '@mui/material';

interface Props {
  open: boolean;
  position: Position;
  closeIconColor: string;
  variant: string;
  drawerVariant: 'temporary' | 'persistent' | 'permanent';
  content: ReactNode;
  sidebarWidth: number;
  rootRef: any,
  onClose: () => void;
}

const PageSidebar = forwardRef((props: Props, ref) => {
  const {
    open = true,
    position = Position.Right,
    closeIconColor,
    variant,
    drawerVariant,
    content,
    sidebarWidth,
    onClose,
  } = props;

  const [isOpen, setIsOpen] = useState(open);

  useImperativeHandle(ref, () => ({
    toggleSidebar: setIsOpen,
  }));

  useEffect(() => {
    setIsOpen(open);
  }, [open]);

  return (
    <>
      <SwipeableDrawer
        variant="temporary"
        anchor={position}
        open={isOpen}
        onOpen={() => {}}
        onClose={() => props?.onClose()}
        disableSwipeToOpen
        classes={{
          root: clsx('FusePageSimple-sidebarWrapper', variant),
          paper: clsx(
            'FusePageSimple-sidebar',
            variant,
            position === 'left' ? 'FusePageSimple-leftSidebar' : 'FusePageSimple-rightSidebar'
          ),
        }}
        sx={{
          display: { lg: 'none', xs: 'block' },
          '& .MuiPaper-root': {
            width: sidebarWidth,
            maxWidth: '100%',
          },
        }}
        ModalProps={{
          keepMounted: true,
        }}
        BackdropProps={{
          classes: {
            root: 'FusePageSimple-backdrop',
          },
        }}
        style={{ position: 'absolute' }}
      >
        <div
          className="flex flex-col flex-auto"
          style={{ width: sidebarWidth }}>
          <div className="cursor-pointer" onClick={onClose}>
            <CloseOutlinedIcon
              className="absolute top-0 right-0 my-16 mx-20 z-10"
              sx={{ color: closeIconColor }}
            />
          </div>

          {content}
        </div>
      </SwipeableDrawer>

      {variant === 'permanent' && (
        <Drawer
          anchor={position}
          variant={drawerVariant}
          className={clsx(
            'FusePageSimple-sidebarWrapper',
            variant,
            isOpen ? 'opened' : 'closed',
            position === 'left'
              ? 'FusePageSimple-leftSidebar'
              : 'FusePageSimple-rightSidebar'
          )}
          sx={{ display: { xs: 'none', lg: 'block' } }}
          open={isOpen}
          onClose={onClose}
          classes={{
            paper: clsx('FusePageSimple-sidebar border-0', variant),
          }}
        >
          <div
            className="flex flex-col flex-auto"
            style={{ width: sidebarWidth }}
          >
            {content}
          </div>
        </Drawer>
      )}
    </>
  );
});

export default PageSidebar;
